 <ng-container card-body>
  <div *ngIf="(unitState$ | async)?.type == 'loading' || (selectExamState$ | async)?.type == 'loading'" class="flex align-items-center justify-content-center">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
</ng-container> 

<split-steps *ngIf="(unitState$ | async)?.type != 'loading' && (selectExamState$ | async)?.type != 'loading'" #steps [isNextStepEnabled]="form.valid && allowNext"
  (stepChange)="onActiveIndexChanged($event)">
  <split-step [passo]="0">
    <form [formGroup]="form" class="mb-6">
      <div class="grid p-fluid">
        <!-- <div class="col-12 p-0 mb-4">
          <div class="flex align-items-center">
            <p-inputSwitch (onChange)="changeAddServiceCode()" formControlName="flagIssuesInvoice"
              class="ml-2"></p-inputSwitch>
            <span class="inputswitch-label ml-2">Nota Fiscal</span>
          </div>
        </div> -->

        <div class="col-12 mb-3">
          <span class="p-float-label">
            <input (keydown)="validateChar($event)" pInputText formControlName="name" id="nomeExame" />
            <label htmlFor="nomeExame" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Nome Exame
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <!-- <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-multiSelect [selectedItemsLabel]="'{0} itens selecionados'" formControlName="units" inputId="float-label" [options]="unidadeFiltrada"
              optionLabel="unitName" optionValue="@id"></p-multiSelect>
            <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">Unidades
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div> -->

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-dropdown [options]="deliveryTime" formControlName="deliveryTime" [autoDisplayFirst]="false"
              optionLabel="label" optionValue="value" [filter]="true" filterBy="label" inputId="float-label">
            </p-dropdown>
            <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Tempo de entrega
               <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>
        <!--
        <div class="col-4 mb-3">
          <span class="p-float-label">
            <p-dropdown [options]="serviceTime" formControlName="serviceTime" [autoDisplayFirst]="false"
              optionLabel="label" optionValue="value" [filter]="true" filterBy="label" inputId="float-label">
            </p-dropdown>
            <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Tempo de atendimento
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>
        -->
        <div class="col-6 mb-3">
          <span class="p-float-label">
            <!-- <input pInputText formControlName="price" id="valor" /> -->
            <p-inputNumber formControlName="value" id="valor" mode="currency" currency="BRL" locale="pt-BR"
              currencyDisplay="symbol"> </p-inputNumber>
            <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Valor
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>
        <!--
        <div class="col-6 mb-3 -mt-3">

          <label for="faixaetaria" class="label-absolute text-xs pl-1 h-1rem flex align-items-center">Faixa
            Etária
            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
          </label>
          <div class="grid p-fluid" id="faixaetaria">
            <div class="col-6">
              <span>
                <p-inputNumber [ngClass]="isMinValid? '' : 'ageGroupInvalid'" [min]="0" [max]="100" placeholder="Mínimo"
                  [ngModelOptions]="{ standalone: true }" (onInput)="updateFaixaEtaria()" [(ngModel)]="ageGroup[0]"
                  id="min"> </p-inputNumber>

              </span>
            </div>
            <div class="col-6">
              <span>
                <p-inputNumber [ngClass]="(isMaxValid)? '' : 'ageGroupInvalid'" [min]="0" [max]="100"
                  placeholder="Máximo" [ngModelOptions]="{ standalone: true }" (onInput)="updateFaixaEtaria()"
                  [(ngModel)]="ageGroup[1]" id="max"></p-inputNumber>
              </span>
            </div>
          </div>

          <div class="col-p12 mt-3" *ngIf="ageGroup[0] || ageGroup[1] > 0">
            <p-slider [animate]="false" [min]="0" [max]="100" [(ngModel)]="ageGroup" (onSlideEnd)="updateFaixaEtaria()"
              class="w-full" [range]="true" [ngModelOptions]="{ standalone: true }">
            </p-slider>
          </div>

        </div>
-->
        <div class="col-12 mb-3">
          <span class="p-float-label">
            <p-dropdown
              [filter]="true"
              filterBy="name"
              [options]="unidadeLista$ | async"
              [autoDisplayFirst]="false"
              formControlName="unit" 
              appendTo="body"
              optionLabel="unitName"
              optionValue="@id"
              inputId=""
            >
            </p-dropdown>
            <label
              class="text-xs pl-1 h-1rem flex align-items-center"
              for="regimeEspecial"
            >
              Unidade
              <img
                class="pl-1"
                src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                alt="alerta-campo-vazio"
              />
              <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                  alt="alerta-campo-vazio" /> -->
            </label>
          </span>
        </div>
        <div class="col-12 mb-3">
          <span class="p-float-label">
            <input pInputText formControlName="description" id="observacoes" />
            <label htmlFor="observacoes" class="text-xs pl-1 h-1rem flex align-items-center">
              Observações
            </label>
          </span>
        </div>

        <!-- <div class="col-12">
          <span class="p-float-label">
            <textarea formControlName="guidelines" id="orientacoes" rows="5" cols="30" pInputTextarea></textarea>
            <label for="orientacoes" class="text-xs pl-1 h-1rem flex align-items-center">
              Orientações
            </label>
          </span>
        </div> -->
      </div>
      <!--
      <ng-container>
        <ng-container formArrayName="serviceCode">
          <ng-container>
            <div class="add-service-code mt-3 p-4 border-round-sm">
              <ng-container *ngFor="
                  let serviceCodeForm of serviceCode.controls;
                  let i = index
                ">
               
                <div class="flex align-items-center py-3" [formGroupName]="i">
                  <div [style.width]="'90%'">
                    <span class="w-full p-float-label p-input-icon-right">
                      <i>
                        <img class="w-1rem" src="assets\icons\service-code-icon.png" alt="alerta-campo-vazio" /></i>
                    
                      <input class="w-full border-round-sm" pInputText id="codigoServicoUnidade"
                        formControlName="code" />
                      <label htmlFor="codigoServicoUnidade" class="text-xs pl-1 h-1rem flex align-items-center">
                        Código de Serviço Unidade
                      </label>
                    </span>
                  </div>

              
                  <div [style.width]="'10%'">

                    <ng-container *ngIf="i == 0 && serviceCode.controls.length == 1">

                      <div class="w-full flex align-items-center justify-content-center">
                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteServiceCode(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>
                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="addServiceCode()">
                            <img src="assets\icons\circle-plus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>

                    </ng-container>

                    <ng-container *ngIf="
                      serviceCode.controls.length != i + 1 &&
                      serviceCode.controls.length > 1
                    ">
                      <div class="w-full flex align-items-center justify-content-center">

                        <div [style.width]="'50%'"></div>

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteServiceCode(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>
                    </ng-container>

                    <ng-container *ngIf="serviceCode.controls.length == i + 1 && i != 0">
                      <div class="w-full flex align-items-center justify-content-center">

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteServiceCode(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="addServiceCode()">
                            <img src="assets\icons\circle-plus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>
                    </ng-container>

                  </div>

                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      -->
    </form>
  </split-step>
  <!-- <split-step [passo]="1" aria-disabled="true">
    <form [formGroup]="form" class="mb-6">
      <ng-container> -->
        <!-- /*  */ -->
        <!-- <div class="message mb-6">
          Selecione quais Unidades você deseja agendar o exame:
        </div> -->
        <!-- /*  */ -->
        <!-- <div class="grid p-fluid"> -->
          <!-- /*  */ -->
          <!-- <div class="col-6 mb-3">
            <span class="p-float-label">
              <p-dropdown (onChange)="onChangeUnit()" formControlName="scheduleRelatedUnit" inputId="float-label"
                [options]="units" optionLabel="unitName" optionValue="@id" [autoDisplayFirst]="false"></p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">Unidade
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3"></div> -->
          <!-- /*  */ -->
          <!-- <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 1)"
                formControlName="weekSeg"></split-select-week>
            </div>
          </div> -->

          <!-- <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 5)"
                formControlName="weekSex"></split-select-week>
            </div>
          </div>

          <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 2)"
                formControlName="weekTer"></split-select-week>
            </div>
          </div>

          <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 6)"
                formControlName="weekSab"></split-select-week>
            </div>
          </div>

          <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 3)"
                formControlName="weekQua"></split-select-week>
            </div>
          </div>

          <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 0)"
                formControlName="weekDom"></split-select-week>
            </div>
          </div> -->

          <!-- <div class="col-6 mb-3">
            <div class="border-1 p-3 borda-ddd border-round-sm">
              <split-select-week (disabledDay)="removeException($event)" (isValid)="validateChildComponent($event, 4)"
                formControlName="weekQui"></split-select-week>
            </div>
          </div> -->
          <!-- <div class="col-12" *ngIf="form.value.exceptions!.length == 0">
            <button class="btn-add-new" (click)="changeAdicionarExcecao()">
              Adicionar Nova Exceção
            </button>
          </div>
        </div> -->

        <!-- <ng-container *ngIf="form.value.exceptions!.length > 0">
          <ng-container formArrayName="exceptions">
            <div class="add-service-code mt-3 p-4 border-round-sm">
              <div class="exception_header flex justify-content-start">
                Exceção
              </div>
              <ng-container *ngFor="
                  let exceptionsForm of exceptions.controls;
                  let i = index
                ">
                <div class="flex w-full mt-4" [formGroupName]="i">
                  <div [style.width]="'50%'">
                    <span>
                      <p-dropdown [emptyMessage]="'sua escala está vazia'" [options]="exceptionsDaysArray"
                        placeholder="Selecionar dia" [autoDisplayFirst]="false" optionLabel="name" optionValue="value"
                        inputId="float-label" formControlName="dayOfTheWeek">
                      </p-dropdown>
                    
                    </span>
                  </div>
                  <div [style.width]="'35%'" class="flex justify-content-center align-items-center">

                    <div [style.width]="'40%'">
                      <input (input)="validateException()"
                        [ngClass]="exceptions.at(i).value.startTime === null? 'inputTimeInvalid': 'inputTimeValid' "
                        class="p-875rem" formControlName="startTime" type="time" />
                    </div>

                    <div class="px-3"> : </div>

                    <div [style.width]="'40%'">
                      <input (input)="validateException()"
                        [ngClass]="exceptions.at(i).value.endTime === null? 'inputTimeInvalid': 'inputTimeValid' "
                        formControlName="endTime" class="p-875rem" type="time" />
                    </div>

                  </div>
                  <div [style.width]="'10%'" class="flex justify-content-center align-items-center">
                    <ng-container *ngIf="i == 0 && exceptions.controls.length == 1">
                      <div class="w-full flex align-items-center">

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteExceptions(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="addExceptions()">
                            <img src="assets\icons\circle-plus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>
                    </ng-container>

                    <ng-container *ngIf="
                      exceptions.controls.length != i + 1 &&
                      exceptions.controls.length > 1
                    ">
                      <div class="w-full flex align-items-center">

                        <div [style.width]="'50%'"></div>

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteExceptions(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>
                    </ng-container>

                    <ng-container *ngIf="exceptions.controls.length == i + 1 && i != 0">
                      <div class="w-full flex align-items-center">

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="deleteExceptions(i)">
                            <img src="assets\icons\tabler_circle-minus.svg" alt="add-service-code" />
                          </button>
                        </div>

                        <div [style.width]="'50%'">
                          <button class="border-none cursor-pointer p-2" (click)="addExceptions()">
                            <img src="assets\icons\circle-plus.svg" alt="add-service-code" />
                          </button>
                        </div>

                      </div>
                    </ng-container>

                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container> -->
      <!-- </ng-container> -->
      <!-- <ng-container *ngIf="showEditTimeSchedule">
        <ng-container card-body>
          <div *ngIf="(isLoading$ | async)" class="flex align-items-center justify-content-center">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
          </div>
        </ng-container>
        <split-table *ngIf="!(isLoading$ | async)" card-body [dados]="scheduleArray" [checklist]="false"
          theme="primary">
          <ng-template #header> <span class="ml-4">Unidade</span> </ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <span class="ml-4">{{getUnitById(item.unit)?.unitName}}</span>
          </ng-template>

          <ng-template #header>Exame</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            {{ form.value.name }} -->

      <!-- <p-badge
              *ngIf="item.exams.length > 1"
              class="pl-1"
              [pTooltip]="tooltipContent"
              tooltipPosition="bottom"
              value="+{{ item.exams.length - 1 }}"
            ></p-badge>

            <ng-template #tooltipContent>
              <div
                class="flex flex-column justify-content-start align-items-start"
              >
                <span
                  class="p-0 text- py-1"
                  *ngFor="let exam of item.exams.slice(1)"
                >
                  {{ exam.exam }}
                </span>
              </div>
            </ng-template> -->
      <!-- </ng-template>

          <ng-template #header>Horário</ng-template>
          <ng-template #coluna let-item="dadosLinha">
            {{getValidItem(item.schedules)[0] }}

            <p-badge *ngIf="getValidItem(item.schedules).length > 1" class="pl-1" [pTooltip]="tooltipContent2"
              tooltipPosition="bottom" value="+{{ getValidItem(item.schedules).length - 1 }}"></p-badge>

            <ng-template #tooltipContent2>
              <div class="flex flex-column justify-content-start align-items-start">
                <span class="p-0 text- py-1">

                  <div *ngFor="let item of getValidItem(item.schedules); let i = index">
                    <ng-template [ngIf]="i != 0">
                      {{item}} <br>
                    </ng-template>
                  </div>

                </span>
              </div>
            </ng-template>

          </ng-template>

          <ng-template #header></ng-template>
          <ng-template #coluna let-item="dadosLinha">
            <div class="flex justify-content-end w-auto">
              <button class="editar border-none bg-white mr-4 action w-2rem h-2rem" (click)="editarExame(item)"
                pTooltip="Editar Exame">
                <img src="assets/lista-unidade/editar.svg" alt="editar exame" />
              </button>
              <button class="excluir border-none bg-white mr-5 action w-2rem h-2rem" (click)="deletarExame(item)"
                pTooltip="Deletar Exame">
                <img src="assets/lista-unidade/excluir.svg" alt="deletar exame" />
              </button>
            </div>
          </ng-template>
        </split-table>

        <div class="flex justify-content-center align-items-center mt-5 mb-6">
          <button class="btn-add-new" (click)="onAddNewTimeTable()">
            Adicionar Novo Horário
          </button>
        </div>
      </ng-container> -->
    <!-- </form>
  </split-step> -->

  <ng-template #customNextButton *ngIf="steps.activeIndex == 0">
    <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- <button type="submit" [disabled]="!allowSave" class="flex ml-auto" [ngClass]="allowSave? '': 'disable' " -->
        <button type="submit" [disabled]="!form.valid" class="flex ml-auto" [ngClass]="form.valid? '': 'disable' "
        split-botao [botao]="{
            titulo: 'Finalizar',
            rota: '/cadastro/exames',
            rightIcon: 'pi-check',
            estilo: 'laranja',
        }"></button>
      <!-- <button type="submit" [disabled]="!allowSubmit" class="flex ml-auto" [ngClass]="allowSubmit? '': 'disable' "
        split-botao [botao]="{
            titulo: 'Finalizar',
            rota: '/cadastro/exames',
            rightIcon: 'pi-check',
            estilo: 'laranja',
        }"></button> -->
    </form>
  </ng-template>
  <!-- <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && showEditTimeSchedule"> -->
  <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->

  <!-- <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <button type="submit" [disabled]="!form.valid" class="flex ml-auto" split-botao [botao]="{
            titulo: 'finalizar',
            rota: '/cadastro/exames',
            rightIcon: 'pi-check',
            estilo: 'laranja',
        }"></button>
    </form>
  </ng-template> -->
</split-steps>